export class AdvancedClusterShapeProvider{}